import { createSelector } from '@reduxjs/toolkit'

export const translationSelector = state => state.translationReducer
export const getLanguageCode = () =>
  createSelector(translationSelector, translation => translation.languageCode)
export const getLocaleStatus = () =>
  createSelector(translationSelector, translation => translation.status)
export const getTranslationList = () =>
  createSelector(translationSelector, translation => translation.resources)
